import React, { useState } from 'react'
import './Nav.css'
import { AiOutlineHome, AiOutlineUser, AiOutlineAccountBook, AiOutlineMessage, AiFillSafetyCertificate } from 'react-icons/ai'
import { RiServiceLine } from 'react-icons/ri'


const Nav = () => {

    const [activeNav, setActiveNav] = useState('#')
    return (
        <nav>

            <a href="#" onClick={() => setActiveNav('#')} className={activeNav === '#' ? 'active' : ""} ><AiOutlineHome /></a>

            <a href="#about" onClick={() => setActiveNav('#about')} className={activeNav === '#about' ? 'active' : ""}><AiOutlineUser /></a>

            <a href="#experience" onClick={() => setActiveNav('#experience')} className={activeNav === '#experience' ? 'active' : ""}><AiOutlineAccountBook /></a>

            <a href="#services" onClick={() => setActiveNav('#services')} className={activeNav === '#services' ? 'active' : ""}><RiServiceLine /></a>

            <a href="#portfolio" onClick={() => setActiveNav('#portfolio')} className={activeNav === '#portfolio' ? 'active' : ""}><AiFillSafetyCertificate /></a>

            <a href="#contact" onClick={() => setActiveNav('#contact')} className={activeNav === '#contact' ? 'active' : ""}><AiOutlineMessage /></a>


        </nav>
    )
}

export default Nav